import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { voiceFlowsActions } from 'features/voiceFlows';

const useVoiceFlows = () => {
  const dispatch = useDispatch();
  const getVoiceFlow = useCallback(() => dispatch(voiceFlowsActions.getVoiceFlow()), [dispatch]);
  const createVoiceFlow = useCallback(voice_flow => dispatch(voiceFlowsActions.createVoiceFlow(voice_flow)), [dispatch]);
  const updateVoiceFlow = useCallback(voice_flow => dispatch(voiceFlowsActions.updateVoiceFlow(voice_flow)), [dispatch]);
  const deleteVoiceFlow = useCallback(() => dispatch(voiceFlowsActions.deleteVoiceFlow()), [dispatch]);
  const clearLocalActiveVoiceFlow = useCallback(() => dispatch(voiceFlowsActions.clearLocalActiveVoiceFlow()), [dispatch]);

  return {
    getVoiceFlow,
    createVoiceFlow,
    updateVoiceFlow,
    deleteVoiceFlow,
    clearLocalActiveVoiceFlow
  };
};

export default useVoiceFlows;